import React, { FC } from 'react';
import { useProduct } from '$shared/utils/product';
import { ImagePreviewer, ImagePreviewerItem } from '$shared/components/image-previewer';
import { ProductImage } from '$shared/components/image';
import { parseProductContent } from "$templates/pages/components/P50ProductDetailPage/components/pdp-tabs/pdp-relationships/product-data-parser";
import { productPDFSrc } from "$shared/utils";

export const PdpImageArea: FC = () => {
    const { photoPath, sketchPath, description1, productData } = useProduct();

    const getFileType = (src: string): 'image' | 'file' | 'x3d' | 'stp' => {
        if (/\.(png|jpg|jpeg|gif|webp)$/i.test(src)) return 'image';
        if (/\.x3d$/i.test(src)) return 'x3d';
        if (/\.stp$/i.test(src)) return 'stp';
        return 'file';
    };

    const itemDataMapper = (srcArr?: (string | undefined)[]): ImagePreviewerItem[] => {
        return (srcArr ?? [])
            .filter((src): src is string => Boolean(src))
            .map((src) => {
                const fileType = getFileType(src);
                return {
                    type: fileType,
                    src: (fileType === 'file' || fileType === 'x3d' || fileType === 'stp') ? productPDFSrc(src) : src,
                    name: (fileType === 'file' || fileType === 'x3d' || fileType === 'stp') ? src : undefined,
                };
            });
    };

    const rawItems = itemDataMapper([
        photoPath,
        sketchPath,
        ...(productData?.flatMap((product) => {
            const parsedContent = parseProductContent(product.content);
            return Array.isArray(parsedContent) ? parsedContent : [];
        }) ?? [])
    ]);

    const usedStpIndices = new Set<number>();
    for (let i = 0; i < rawItems.length; i++) {
        const item = rawItems[i];
        if (item.type === 'x3d' && item.name) {
            const base = item.name.split('.').slice(0, -1).join('.');
            for (let j = 0; j < rawItems.length; j++) {
                const candidate = rawItems[j];
                if (candidate.type === 'stp' && candidate.name) {
                    const stpBase = candidate.name.split('.').slice(0, -1).join('.');
                    if (base === stpBase) {
                        (item as any).linkedStp = { name: candidate.name, src: candidate.src };
                        usedStpIndices.add(j);
                        break;
                    }
                }
            }
        }
    }
    const finalItems = rawItems.filter((_, index) => !usedStpIndices.has(index));

    return (
        <ImagePreviewer itemsData={finalItems}>
            {(item) =>
                item.type === 'image' ? (
                    <ProductImage
                        width={50}
                        height={50}
                        alt={description1}
                        src={item.src}
                        style={{ pointerEvents: 'none' }}
                    />
                ) : (
                    <div
                        style={{
                            width: '100%',
                            height: '100%',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center'
                        }}
                    >
                        {(item.type === 'x3d' && (item as any).linkedStp)
                            ? 'STP'
                            : item.name?.split('.').pop()?.toUpperCase()
                        }
                    </div>
                )
            }
        </ImagePreviewer>
    );
};